import savePartnerId from './save-partner-id';

export default {
  savePartnerId,
};
